import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import StepContainer from "./StepContainer";
import GradientButton from "../../Core/GradientButton";

export default function Outro() {
	const navigate = useNavigate();
	return (
		<StepContainer title="">
			<Row className="mb-4">
				<Col>
					<h4 className="text-center">Thank you for signing up with Zing Fibre.</h4>
				</Col>
			</Row>
			<Row className="mb-4">
				<Col>
					<h5 className="text-center">
						For more information or to follow up, please WhatsApp us on 087 056 1218.
					</h5>
				</Col>
			</Row>
			<Row className="text-center">
				<Col xs={12} lg={6} className="offset-xs-0 offset-lg-3">
					<GradientButton
						title="Click here to login"
						variant="greenYellow"
						onClick={() => navigate("/", { state: { login: true } })}
					/>
				</Col>
			</Row>
		</StepContainer>
	);
}
